import "core-js/modules/es.reflect.construct.js";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["guid"];
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { Event } from '../event';
import Cookie from '../utils/cookie';
var randomString = function randomString() {
  var digits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
  return Math.random().toString(36).slice(2, 2 + digits).toUpperCase();
};

// guid 格式如：  258EAFA5-E914-47DA-95CA-C5AB0DC85B11
var guid = function guid() {
  return [randomString(), randomString(3), randomString(3), randomString(3), randomString(12)].join('-');
};

/** 消息超时设置 */
var MESSAGE_TIMEOUT = 100000;

// 【 腾竞 APP 演出接入文档： https://wiki.maoyan.com/x/Kk4EBg 】
var TJAppBridge = /*#__PURE__*/function (_Event) {
  _inherits(TJAppBridge, _Event);
  var _super = _createSuper(TJAppBridge);
  function TJAppBridge() {
    _classCallCheck(this, TJAppBridge);
    return _super.apply(this, arguments);
  }
  _createClass(TJAppBridge, [{
    key: "bindOnMessage",
    value:
    /**
     * 接收腾竞 APP 原生 API 调用后消息返回
     *
     * @param {*} message
     * @memberof TJAppBridge
     */
    function bindOnMessage(message) {
      var guid = message.guid,
        others = _objectWithoutProperties(message, _excluded);
      this.trigger(guid, others);
    }
    /**
     * JS 调用 原生API 方法
     *
     * @param {*} params
     * @returns
     * @memberof TJAppBridge
     */
  }, {
    key: "postMsg",
    value: function postMsg(params) {
      var _this = this;
      if (Object.prototype.toString.call(params) !== '[object Object]' && !params.api) throw Error('参数不合法');
      // 生成 guid
      var GUID = guid();
      params.guid = GUID;
      // 消息发送
      window.nativeBridge && window.nativeBridge.postMessage(JSON.stringify(params));
      // 超时处理
      var timer = setTimeout(function () {
        _this.trigger(GUID, {
          success: false
        });
      }, MESSAGE_TIMEOUT);
      return new Promise(function (resolve) {
        return _this.once(GUID, resolve);
      });
    }
    /**
     * 获取APP、系统相关信息
     *
     * @returns <Promise>
     * @memberof TJAppBridge
     */
  }, {
    key: "getAppInfo",
    value: function getAppInfo() {
      return this.postMsg({
        api: 'GetAppInfo'
      });
    }
    /**
     * 打开新的容器
     *
     * @param {string} [opts={ url: '', jump: false }]  jump: 是否关闭当前容器
     * @returns <Promise>
     * @memberof TJAppBridge
     */
  }, {
    key: "openWebview",
    value: function openWebview() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        url: '',
        jump: false
      };
      return this.postMsg({
        api: 'OpenPage',
        data: {
          url: opts.url,
          closeCurrentPage: !!opts.jump
        }
      });
    }
    /**
     * 关闭当前 webview 容器
     *
     * @returns <Promise>
     * @memberof TJAppBridge
     */
  }, {
    key: "closeWebview",
    value: function closeWebview() {
      return this.postMsg({
        api: 'CloseWebview'
      });
    }
    /**
     *  获取定位
     *
     * @returns <Promise>
     * @memberof TJAppBridge
     */
  }, {
    key: "getLocation",
    value: function getLocation() {
      return this.postMsg({
        api: 'GetLocation'
      });
    }
    /**
     * 分享
     *
     * @memberof TJAppBridge
     */
  }, {
    key: "share",
    value: function share() {}
  }]);
  return TJAppBridge;
}(Event); // 必须 为 window 全局变量， 涉及腾竞 APP 原生调用JS通知 API调用 结果
window.TJAppBridge = new TJAppBridge();
export var TJBridge = new TJAppBridge();

// 点评APP
export default {
  appName: 'tengjing',
  useKNB: false,
  sellChannel: 22,
  theme: 'maoyan',
  hostPrefix: '//show.maoyan.com/TJSports',
  hostBetaPrefix: '//show.test.maoyan.com/TJSports',
  ajaxUrl: '//yanchu.maoyan.com/myshow/ajax',
  ajaxBetaUrl: '//m.51ping.com/myshow/ajax',
  tokenCookie: 'tj_show_token',
  getUserInfo: function getUserInfo() {
    var cookieInfoArr = (Cookie.get('_source__from_') || '').split('||');
    return {
      token: cookieInfoArr[1] || '',
      openId: cookieInfoArr[2] || '',
      userId: cookieInfoArr[3] || ''
    };
  },
  /**
   * 登录方法
   */
  login: function login() {
    location.hash = "/tj/auth".concat(location.hash.replace('#', ''));
  }
};